import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "copywriting-data"
};
import { ref, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/index'

// import newQuillEditor from '@/components/newQuillEditor/newQuillEditor.vue';

export default {
  __name: 'CopywritingData',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  emits: ['update:content'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emits = __emit;
    let props = __props;
    let readOnly = ref(false);
    let formRef = ref(null);
    let newQuillEditorRef = ref(null);
    const formData = ref({
      mainContent: '',
      selectedWordCount: ''
    });
    const rules = {
      mainContent: [{
        required: true,
        message: '请输入主要内容',
        trigger: 'blur'
      }],
      selectedWordCount: [{
        required: false,
        message: '请选择字数',
        trigger: 'change'
      }]
    };
    watch(() => props.content, templateContent => {
      formData.value.mainContent = templateContent;
      // let refs = newQuillEditorRef.value
      // refs.setHighlightEchoFn('asdas超级喜欢就好{案说法}案说法')
    });
    const submitForm = () => {
      return new Promise((resolve, reject) => {
        formRef.value.validate(valid => {
          const form = {
            ...formData.value
          };
          if (valid) {
            form.customContent = form.selectedWordCount ? `请帮我生成一篇 ${form.selectedWordCount} 字的文案。文案内容如下：${form.mainContent}` : form.mainContent;
            resolve({
              valid,
              form
            });
          } else {
            reject({
              valid,
              form
            });
          }
        });
      });
    };
    __expose({
      submitForm
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "title",
        onClick: submitForm
      }, "指令收集区"), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "subtitle"
      }, "请在输入框内详细输入信息，即可生成！", -1)), _createVNode(_component_el_form, {
        class: "editor-form",
        model: formData.value,
        "label-position": "top",
        rules: rules,
        ref_key: "formRef",
        ref: formRef
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          class: "editor-content",
          label: "主要内容",
          prop: "mainContent"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            resize: "none",
            type: "textarea",
            modelValue: formData.value.mainContent,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.mainContent = $event),
            modelModifiers: {
              trim: true
            },
            placeholder: "请输入主要的内容，我们建议您详细涵盖主题概述、作者视角或身份背景、核心关键词等具体信息；表述越清晰、条理越分明，我们的文案助理就能更加快速而准确地理解您的创作意图和需求，从而为您提供更加贴切和高质量的辅助服务。（必填项）"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "精简字数",
          prop: "selectedWordCount"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            clearable: "",
            modelValue: formData.value.selectedWordCount,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.selectedWordCount = $event),
            placeholder: "可选择您需要的文章字数"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "尽量将文章内容精简至：50字左右",
              value: "50"
            }), _createVNode(_component_el_option, {
              label: "尽量将文章内容精简至：100字左右",
              value: "100"
            }), _createVNode(_component_el_option, {
              label: "尽量将文章内容精简至：200字左右",
              value: "200"
            }), _createVNode(_component_el_option, {
              label: "尽量将文章内容精简至：300字左右",
              value: "300"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
};